import axios from "axios";
import { PageDefinitions } from "@/interfaces/PageDefinitions";
import { CustomPageMeta } from "@/interfaces/CustomPageMeta";
import { Page } from "@/interfaces/Page";

export function loadPageData(baseUrl: string): Promise<PageDefinitions> {
  return new Promise((resolve, reject) => {
    axios
      .get<PageDefinitions>(`${baseUrl}pages.json`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject({ message: "Unable to load page data." });
      });
  });
}

export function postPage(
  baseUrl: string,
  token: string,
  payload: { id: string; img: string }
): Promise<CustomPageMeta> {
  return new Promise((resolve, reject) => {
    console.log("Posting a page.", payload);
    axios
      .post<CustomPageMeta>(
        `${baseUrl}api/generate`,
        {
          ...payload
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(response => {
        resolve(response.data);
      })
      .catch(err => reject(err));
  });
}

export function loadDynamicPage(
  id: string,
  baseUrl: string
): Promise<Page & CustomPageMeta> {
  return new Promise((resolve, reject) => {
    // Use context
    Promise.all([
      loadPageData(baseUrl),
      axios.get<CustomPageMeta>(`${baseUrl}share/${id}/page.json`)
    ])
      .then(([pages, dynamicRes]) => {
        console.log(pages);

        const data = pages.find(o => o.id == dynamicRes.data.id);
        if (data == null) {
          return reject({ message: "page not found" });
        }
        // Resolve the combined data
        resolve({ ...data, ...dynamicRes.data });
      })
      .catch(reject);
  });
}
